import { AutoCompleteAdvantages } from '@components/AutoComplete/AutoCompleteAdvantages';
import InputRichText from '@components/InputRichText';
import { useOptionsContext } from '@modules/talents/context/options-context';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

const JobOfferWhyChooseUsForm = () => {

    const { data: optionsData } = useOptionsContext();
    const options = useMemo(() => optionsData?.options, [optionsData]);
    const { control } = useFormContext();

    const getPlaceholder = () => {
        if (options?.advantages?.[0]?.children?.[0]?.name) {
            return `Ex: ${options.advantages[0].children[0].name}`;
        }
        return 'Sélectionnez les avantages';
    };
    return (
        <>
            <InputRichText
                label="Avantages et atouts"
                control={control}
                name="description.advantages"
                placeholder="Inscrivez ici tous les avantages que vous offrez à vos salariés ainsi que les atouts de votre établissement. Ex : Parking, Salle de repos, Travail en musique, Mutuelle, Tickets resto ..."
                defaultValue={undefined}
            />
            <AutoCompleteAdvantages
                label="Liste des avantages et atouts"
                placeholder={getPlaceholder()}
                groupedOptions={options?.advantages}
                control={control}
                name="description.listAdvantages"
                allowAdd={true}
                rules={{
                    required: 'Veuillez sélectionner au moins un avantage',
                }}
                onChange={val => {
                    // Validate max 6 items
                    if (val?.length > 6) {
                        console.warn('Vous ne pouvez pas sélectionner plus de 6 avantages');
                        return;
                    }
                }}
            />
        </>
    );
};

export default JobOfferWhyChooseUsForm;
